export const themeTokens = {
  token: {
    colorPrimary: '#005792',      // industrial blue
    colorSuccess: '#3FA34D',      // green
    colorWarning: '#F5A623',      // orange
    colorError: '#D64545',        // red
    colorBgLayout: '#f4f6f8',     // light gray background
    colorBgContainer: '#ffffff',  // white cards/forms
    borderRadius: 8,
    fontFamily: 'Arial, sans-serif',
  },
};
